import {Injectable} from '@angular/core';
import {hasValue} from '@shared/utils/helpers';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() {
  }

  getItem<T>(key: string): T | string {
    const item = window.localStorage.getItem(key);
    if (!hasValue(item)) {
      return null;
    }

    try {
      return JSON.parse(item) as T;
    } catch (e) {
      return item;
    }
  }

  setItem(key: string, value: any) {
    if (typeof value !== 'string') {
      value = JSON.stringify(value);
    }

    window.localStorage.setItem(key, value);
  }

  removeItem(key: string) {
    window.localStorage.removeItem(key);
  }
}
